﻿module.exports = function () {
  $.extend(jQuery.validator.messages, {
    required: App.Text.get("FieldRequired", "Validation"),
    remote: App.Text.get("Remote", "Validation"),
    email: App.Text.get("InvalidEmail", "Validation"),
    url: App.Text.get("Url", "Validation"),
    date: App.Text.get("Date", "Validation"),
    dateISO: App.Text.get("DateISO", "Validation"),
    number: App.Text.get("Number", "Validation"),
    digits: App.Text.get("Digits", "Validation"),
    creditcard: App.Text.get("CreditCard", "Validation"),
    equalTo: App.Text.get("OnceAgain", "Validation"),
    accept: App.Text.get("Accept", "Validation"),
    maxlength: jQuery.validator.format(App.Text.get("LimitCharacterMore", "Validation")),
    minlength: jQuery.validator.format(App.Text.get("LimitCharacterLess", "Validation")),
    rangelength: jQuery.validator.format(App.Text.get("InvalidEmail", "Validation")),
    range: jQuery.validator.format(App.Text.get("Range", "Validation")),
    max: jQuery.validator.format(App.Text.get("Max", "Validation")),
    min: jQuery.validator.format(App.Text.get("Min", "Validation")),
    nospaces: App.Text.get("NoSpaces", "Validation"), //Spaces are not allowed
  })
}
